import { MissionType } from '@/const/mission';

export const SCENE_SOURCE_NODE_ID = '1';

export const enum NodeEnums {
  story = 'story',
  chapter = 'chapter',
  scene = 'scene',
  gamePlay = 'gamePlay',
  startMission = 'startMission',
  mainMission = 'mainMission',
  successMission = 'successMission',
  failMission = 'failMission',
  endMission = 'endMission',
  propsMission = 'propsMission',

  passCondition = 'passCondition',
  trapCondition = 'trapCondition',
  jump = 'jump',

  // tools
  collapse = 'collapse', // 折叠节点
  addCondition = 'addCondition',

  // storyLine
  storyLineScene = 'storyLineScene', // 故事线场景
  storyLineCondition = 'storyLineCondition' // 故事线条件
}

export const nodeEnumMissionToType = {
  [NodeEnums.startMission]: MissionType.MISSION_TYPE_PROLOGUE,
  [NodeEnums.mainMission]: MissionType.MISSION_TYPE_MAINLINE,
  [NodeEnums.successMission]: MissionType.MISSION_TYPE_SUCCESS,
  [NodeEnums.failMission]: MissionType.MISSION_TYPE_FAILURE,
  [NodeEnums.endMission]: MissionType.MISSION_TYPE_ENDING,
  [NodeEnums.propsMission]: MissionType.MISSION_TYPE_PROPS,
};

export const mainMissionCardWH = {
  normal: { // max 2
    width: 1130,
    height: 316,
  },
  middle: { // max 3
    width: 1130,
    height: 316,
  },
  large: { // min 4
    width: 1130,
    height: 523,
  },
  max: {
    width: 1130,
    height: 583,
  },
};

export const successMissionWH = {
  normal: {
    width: 40,
    height: 40,
  },
  special: {
    width: 126,
    height: 46,
  },
};

export const EDGE_WIDTH = 80;
